import React from 'react';

import styled from 'styled-components';

import Radio from 'components/lib/Radio';

import { useCompaniesCreateEditModalContext } from './CompaniesCreateEditModalContext';
import { COMPANY_KEYS, SHOP_PRIORITIES, SHOP_PRIORITIES_LABELS } from './constants';

const TextContainer = styled.div`
  margin-top: 30px;
  margin-bottom: 15px;
`;

const Label = styled.div`
  font-size: 14px;
  font-family: var(--font-bold);
  color: var(--text-primary);
`;

const Text = styled.div`
  font-size: 12px;
  color: var(--text-secondary);
`;

const StyledRadioGroup = styled(Radio.Group)`
  display: flex;
  flex-flow: column;
`;

const StyledRadioButton = styled(Radio)`
  font-family: var(--font-regular);
  font-size: 14px;
  margin-bottom: 10px;
  display: flex;
  flex-flow: row;
  align-items: center;
`;

const CompaniesCreateEditModalContentMysteryShoppingShopPriority = () => {
  const { company, handleChange } = useCompaniesCreateEditModalContext();
  const { shop_priority = SHOP_PRIORITIES.MEDIUM } = company?.mystery_shop_setting ?? {};

  const handlePriorityChange = (event: any) => {
    const mystery_shop_setting = { ...company?.mystery_shop_setting };
    mystery_shop_setting.shop_priority = event.target.value;
    handleChange(COMPANY_KEYS.MYSTERY_SHOP_SETTING, mystery_shop_setting);
  };

  return (
    <div>
      <TextContainer>
        <Label>Shop Priority</Label>
        <Text>Companies with higher priority will appear first in the list of shop requests.</Text>
      </TextContainer>
      <StyledRadioGroup value={shop_priority} onChange={handlePriorityChange}>
        {Object.values(SHOP_PRIORITIES).map((priority) => (
          <StyledRadioButton key={priority} value={priority}>
            {SHOP_PRIORITIES_LABELS[priority]}
          </StyledRadioButton>
        ))}
      </StyledRadioGroup>
    </div>
  );
};

export default CompaniesCreateEditModalContentMysteryShoppingShopPriority;
